import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import {
  FaUserPlus,
  FaEnvelope,
  FaIdCard,
  FaCheckCircle,
  FaChevronDown,
  FaChevronUp,
} from 'react-icons/fa';
import { PrimaryButton } from '../../../components';
import styles from './AlokaOnboarding.module.css';
// Todo: Deprecate siltUserStatus.

const AlokaOnboarding = ({ user, intl }) => {
  if (user?.attributes?.profile?.metadata?.siltUserStatus === 'SUCCESS' || user === null) {
    return null;
  }
  const [currentStep, setCurrentStep] = useState(0);
  const [verificationStatus, setVerificationStatus] = useState('');
  const [isExpanded, setIsExpanded] = useState(false);
  // const intl = useIntl();
  const history = useHistory();

  const steps = [
    {
      name: intl.formatMessage({ id: 'AlokaOnboarding.createAccount' }),
      icon: FaUserPlus,
      link: !user?.attributes?.emailVerified ? '/signup/verify-email': '/signup',
    },
    {
      name: intl.formatMessage({ id: 'AlokaOnboarding.verifyEmail' }),
      icon: FaEnvelope,
      link: user?.attributes?.emailVerified ? '/verify-email' : '/signup/verify-email',
    },
    {
      name: intl.formatMessage({ id: 'AlokaOnboarding.verifyIdentity' }),
      icon: FaIdCard,
      link: !user?.attributes?.emailVerified ? '/signup/verify-email' : '/signup',
    },
    {
      name: intl.formatMessage({ id: 'AlokaOnboarding.complete' }),
      icon: FaCheckCircle,
      link: '/account/contact-details',
    },
  ];

  useEffect(() => {
    if (user) {
      const { attributes } = user;
      if (attributes?.createdAt) setCurrentStep(1);
      if (attributes?.emailVerified && attributes.pendingEmail === null) setCurrentStep(2);
      if (
        // Todo: Deprecate siltUserStatus.
        attributes?.profile?.metadata?.userVerificationStatus === 'completed' ||
        attributes?.profile?.metadata?.siltUserStatus === 'SUCCESS' ||
        attributes?.profile?.metadata?.userVerificationStatus === 'Approved'
      ) {
        setCurrentStep(3);
      } else if (attributes?.profile?.metadata?.userVerificationStatus === 'PENDING') {
        setVerificationStatus('pending');
      } else if (attributes?.profile?.metadata?.userVerificationStatus === 'ERROR') {
        setVerificationStatus('error');
      }
    }
  }, [user]);

  const toggleExpand = () => setIsExpanded(!isExpanded);

  return (
    <div className={styles.container}>
      <div className={styles.progressLine}>
        {steps.map((step, index) => (
          <Link
            key={step.name}
            to={step.link}
            className={`${styles.step} ${index === currentStep ? styles.active : ''} ${
              index < currentStep ? styles.completed : ''
            }`}
            aria-label={intl.formatMessage({ id: 'AlokaOnboarding.goTo' }, { step: step.name })}
          >
            <div className={styles.stepIcon}>
              {index < currentStep ? (
                <FaCheckCircle className={styles.completedIcon} />
              ) : (
                <step.icon
                  className={index === currentStep ? styles.activeIcon : styles.inactiveIcon}
                />
              )}
            </div>
            <span className={styles.stepName}>{step.name}</span>
          </Link>
        ))}
      </div>
      <button onClick={toggleExpand} className={styles.expandButton}>
        {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
      </button>
      {isExpanded && (
        <div className={styles.expandedContent}>
          <h1 className={styles.title}>
            <FormattedMessage id="AlokaOnboarding.title" />
          </h1>
          <div className={styles.currentStatus}>
            {currentStep < steps.length - 1 ? (
              <>
                <p>
                  <FormattedMessage
                    id="AlokaOnboarding.currentStep"
                    values={{ step: <strong>{steps[currentStep].name}</strong> }}
                  />
                </p>
                {verificationStatus === 'pending' && (
                  <p className={styles.pendingMessage}>
                    <FormattedMessage id="AlokaOnboarding.verificationPending" />
                  </p>
                )}
                {verificationStatus === 'error' && (
                  <p className={styles.errorMessage}>
                    <FormattedMessage id="AlokaOnboarding.verificationError" />
                  </p>
                )}
                <PrimaryButton
                  onClick={() => history.push(steps[currentStep].link)}
                  className={styles.actionButton}
                >
                  <FormattedMessage id={`AlokaOnboarding.step${currentStep}`} />
                </PrimaryButton>
              </>
            ) : (
              <p className={styles.completionMessage}>
                <FormattedMessage id="AlokaOnboarding.completionMessage" />
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AlokaOnboarding;
